(function () {
    'use strict';

    function overflowToggle($compile, $timeout, $rootScope, scrollingService) {

        return {
            restrict: 'A',
            scope: {
                toggleButtonExpandText: '@',
                toggleButtonCollapseText: '@',
                toggleTriggerName: '@',
                toggleTriggerMatchData: '=',
                toggleEnabled: '='
            },
            link: function (scope, element, attrs) {
                if ('showToggleText' in attrs) {
                    scope.showToggleText = true;
                }

                if (!scope.toggleEnabled) {
                    return;
                }

                if (!attrs.maxHeight) {
                    throw new Error('max-height is missing');
                }

                if (!attrs.toggleButtonExpandText) {
                    throw new Error('toggle-button-expand-text is missing');
                }

                if (!attrs.toggleButtonCollapseText) {
                    throw new Error('toggle-button-collapse-text is missing');
                }

                if (!attrs.toggleButtonClass) {
                    throw new Error('toggle-button-class is missing');
                }

                if (!attrs.toggleButtonId) {
                    throw new Error('toggle-button-id is missing');
                }

                if (!attrs.toggleButtonScrollOffset) {
                    throw new Error('toggle-button-scroll-offset is missing');
                }

                scope.isExpanded = true;
                var maxHeight = 0;
                var toggleOffset = 0;
                var expandedHeight = 0;

                scope.toggleOverflow = function () {
                    if (scope.isExpanded) {
                        $(element).css('max-height', attrs.maxHeight + 'px');
                        $(element).css('overflow', 'hidden');
                    }
                    else {
                        $(element).css('max-height', '');
                        $(element).css('overflow', '');
                    }

                    if (scope.isInitialized) {
                        scrollingService.scrollTo(attrs.toggleButtonId,
                            scope.isExpanded ? toggleOffset : toggleOffset + expandedHeight, 0, 0);
                    }

                    scope.isExpanded = !scope.isExpanded;
                    scope.isInitialized = true;
                }

                if (attrs.toggleTriggerName) {
                    $rootScope.$on(attrs.toggleTriggerName, function (event, args) {
                        if (angular.equals(args, scope.toggleTriggerMatchData)) {
                            initialize();
                        }
                    });
                }

                scope.initialized = false;

                function generateTemplate(toggleButtonId, toggleButtonClass) {
                    var templateWithoutText = '<div id="' +
                        toggleButtonId +
                        '" ng-click="toggleOverflow()" class="overflow-toggle ' +
                        toggleButtonClass +
                        '">' +
                        '<div class="sr-only" ng-bind="isExpanded ? toggleButtonCollapseText : toggleButtonExpandText" class="overflow-toggle-label"></div>' +
                        '<icon class="fa fa-pause fa-rotate-90"></icon><icon class="fa fa-pause fa-rotate-90"></icon>' +
                        '</div>';

                    var templateWithText = '<div id="' +
                        toggleButtonId +
                        '" ng-click="toggleOverflow()" class="overflow-toggle ' +
                        toggleButtonClass +
                        '">' +
                        '<div ng-bind="isExpanded ? toggleButtonCollapseText : toggleButtonExpandText" class="overflow-toggle-label"></div>' +
                        '</div>';
                    return scope.showToggleText ? templateWithText : templateWithoutText;
                }

                function initialize() {
                    expandedHeight = $(element).height();
                    toggleOffset = parseInt(attrs.toggleButtonScrollOffset, 10);
                    maxHeight = parseInt(attrs.maxHeight, 10);
                    if ($(element).height() > maxHeight) {
                        $(element).parent().append($compile(generateTemplate(attrs.toggleButtonId, attrs.toggleButtonClass))(scope));
                        scope.toggleOverflow();
                    }
                }
            }
        };
    };

    overflowToggle.$inject = ['$compile', '$timeout', '$rootScope', 'scrollingService'];
    angular.module('ecap.common').directive('overflowToggle', overflowToggle);
})();